(function () {
  'use strict';

  function initAll() {
    document.querySelectorAll('.amiro-product-subscription-selector:not([data-subsel-ready])').forEach(init);
  }

  function init(root) {
    root.setAttribute('data-subsel-ready', '');

    var cards = Array.prototype.slice.call(root.querySelectorAll('.subsel__card'));
    if (cards.length === 0) return;

    var mainProduct = root.closest('amiro-main-product');

    // Read max discount from Liquid-rendered data attributes for the tab label.
    var maxVal = 0;
    var maxFormatted = '';
    cards.forEach(function (card) {
      var val = Number(card.dataset.saveValue) || 0;
      if (val > maxVal) {
        maxVal = val;
        maxFormatted = card.dataset.saveFormatted || '';
      }
    });

    var saveSuffix  = root.querySelector('[data-js="save-suffix"]');
    var maxDiscount = root.querySelector('[data-js="max-discount"]');
    if (saveSuffix && maxDiscount) {
      if (maxVal > 0) {
        maxDiscount.innerHTML = maxFormatted;
        saveSuffix.hidden = false;
      } else {
        saveSuffix.hidden = true;
      }
    }

    // ---- Tabs / variant selection state ----
    var subModes = { 'subscription': 1, 'subscribe-and-save': 1, 'subscribe_and_save': 1 };
    var state = {
      mode: subModes[root.dataset.defaultOption] ? 'sub' : 'otp',
      variantId: root.dataset.selectedVariant
    };

    if (state.mode === 'sub' && root.dataset.defaultPlan) {
      var wantedPlan = String(root.dataset.defaultPlan).split('/').pop();
      var matched = cards.find(function (c) {
        return String(c.dataset.sellingPlan).split('/').pop() === wantedPlan;
      });
      if (matched) state.variantId = matched.dataset.variantId;
    }

    if (root.dataset.reverseOption === 'true') {
      var tabs = root.querySelector('.subsel__tabs');
      if (tabs && tabs.children.length === 2) {
        tabs.insertBefore(tabs.children[1], tabs.children[0]);
      }
    }

    function selectedCard() {
      return cards.find(function (c) { return c.dataset.variantId === state.variantId; }) || cards[0];
    }

    function syncFrequency() {
      root.querySelectorAll('.subsel__freq-value').forEach(function (el) {
        el.hidden = el.dataset.variantId !== state.variantId;
      });
    }

    function syncOuter() {
      var hasVariantOptions = false;
      if (mainProduct) {
        var variantOptions = mainProduct.querySelectorAll('amiro-product-variants form variant-option');
        hasVariantOptions = variantOptions.length > 0;
        variantOptions.forEach(function (vo) {
          var checkbox = vo.querySelector("input[name='id[]']");
          var quantityInput = vo.querySelector("input[name='quantity[]']");
          if (vo.getAttribute('data-variant-id') === state.variantId) {
            if (checkbox) checkbox.checked = true;
            vo.classList.add('selected');
            if (quantityInput && parseInt(quantityInput.value) < 1) quantityInput.value = '1';
          } else {
            if (checkbox) checkbox.checked = false;
            vo.classList.remove('selected');
          }
        });

        // Fallback: when no variant-option blocks exist, push variantId into the
        // main add-to-cart form so theme's calcPrice can read the selection.
        if (!hasVariantOptions && state.variantId) {
          var form = mainProduct.querySelector('form[action*="/cart/add"]');
          if (form) {
            var idInput = form.querySelector('input[name="id"]');
            if (!idInput) {
              idInput = document.createElement('input');
              idInput.type = 'hidden';
              idInput.name = 'id';
              form.appendChild(idInput);
            }
            if (idInput.value !== state.variantId) {
              idInput.value = state.variantId;
              form.dispatchEvent(new Event('change', {bubbles: true}));
            }
          }
        }
      }

      var sellingPlan = '';
      if (state.mode === 'sub') {
        var card = selectedCard();
        sellingPlan = card ? String(card.dataset.sellingPlan).split('/').pop() : '';
      }
      root.setAttribute('data-selling-plan', sellingPlan);

      cards.forEach(function (card) {
        var radio = card.querySelector('input[type="radio"][name="subsel-variant"]');
        if (radio) radio.checked = (card.dataset.variantId === state.variantId);
      });

      if (typeof window.calcPrice === 'function') window.calcPrice();
      if (typeof window.toggleGallery === 'function') window.toggleGallery();

      // Directly write prices into the main product price blocks — the theme's
      // calcPrice() relies on <variant-option> elements which this page omits,
      // so we override the rendered output based on the current card + mode.
      var currentCard = selectedCard();
      if (currentCard) {
        var isSub = state.mode === 'sub' && currentCard.dataset.sellingPlan;
        var priceHtml = isSub ? currentCard.dataset.subMoney : currentCard.dataset.otpMoney;
        var compareHtml = isSub ? currentCard.dataset.subCompare : currentCard.dataset.otpCompare;
        var showCompare = isSub && priceHtml !== compareHtml;

        var priceBlock = document.querySelector('.amiro-main-product-details .block__price amiro-product-price');
        if (priceBlock) {
          priceBlock.classList.toggle('is-save', showCompare);
          priceBlock.innerHTML =
            '<div class="price">' + priceHtml + '</div>' +
            '<div class="compare_at_price">' + (showCompare ? compareHtml : '') + '</div>';
        }

        var bottomPrice = document.querySelector('.amiro-product-add-to-cart-bottom .price');
        if (bottomPrice) bottomPrice.innerHTML = priceHtml;
        var bottomCompare = document.querySelector('.amiro-product-add-to-cart-bottom .compare-at-price');
        if (bottomCompare) bottomCompare.innerHTML = showCompare ? compareHtml : '';
      }
    }

    function render() {
      root.setAttribute('data-mode', state.mode);
      root.querySelectorAll('.subsel__tab').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mode === state.mode);
      });
      cards.forEach(function (c) {
        c.classList.toggle('is-selected', c.dataset.variantId === state.variantId);
      });
      syncFrequency();
      syncOuter();
      root.dispatchEvent(new CustomEvent('subsel:change', {
        bubbles: true,
        detail: {
          mode: state.mode,
          variantId: state.variantId,
          sellingPlanId: state.mode === 'sub'
            ? (selectedCard() && String(selectedCard().dataset.sellingPlan).split('/').pop())
            : null
        }
      }));
    }

    root.querySelectorAll('.subsel__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.mode = tab.dataset.mode;
        render();
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.dataset.available === 'false') return;
        if (e.target && e.target.tagName === 'INPUT') return;
        state.variantId = card.dataset.variantId;
        render();
      });
      var radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) {
            state.variantId = card.dataset.variantId;
            render();
          }
        });
      }
    });

    // Patch cartItems on amiro-main-product to inject selling_plan
    // and add the variant when no variants block is present.
    if (mainProduct) {
      var proto = Object.getPrototypeOf(mainProduct);
      var desc = Object.getOwnPropertyDescriptor(proto, 'cartItems');
      if (desc && desc.get) {
        var origGet = desc.get;
        Object.defineProperty(mainProduct, 'cartItems', {
          get: function () {
            var result = origGet.call(this);
            var sp = root.getAttribute('data-selling-plan');
            var vid = state.variantId;
            var found = false;

            if (vid) {
              result.items.forEach(function (item) {
                if (String(item.id) === String(vid)) {
                  found = true;
                  if (sp) item.selling_plan = Number(sp);
                }
              });
            }

            if (!found && vid) {
              var item = { id: Number(vid), quantity: 1 };
              if (sp) item.selling_plan = Number(sp);
              result.items.unshift(item);
            }

            return result;
          }
        });
      }
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
